<template>
  <Pager>
    <Buttons
      v-if="pagination.show_first"
      :disabled="!pagination.has_previous"
      class="dea-pager__button dea-button--large dea-button--square dea-button--outline"
      icon="freccia-left"
      @click="loadPage('first')"
    ></Buttons>
    <Buttons
      v-if="pagination.has_previous"
      class="dea-pager__button dea-button--large dea-button--square dea-button--outline"
      @click="loadPage('prev')"
      >...</Buttons
    >
    <Buttons
      v-for="item in pagination.pages"
      :key="item.number"
      :class="{ 'dea-button--outline': item.clickable }"
      class="dea-pager__button dea-button--large dea-button--square"
      @click="loadPage(item.number)"
      >{{ item.number }}</Buttons
    >
    <Buttons
      v-if="pagination.has_next"
      class="dea-pager__button dea-button--large dea-button--square dea-button--outline"
      @click="loadPage('next')"
      >...</Buttons
    >
    <Buttons
      v-if="pagination.show_last"
      :disabled="!pagination.has_next"
      class="dea-pager__button dea-button--large dea-button--square dea-button--outline"
      icon="freccia-right"
      @click="loadPage('last')"
    ></Buttons>
  </Pager>
</template>

<script>
import Buttons from "@/components/elements/Buttons";

import Pager from "@/components/elements/Pager";

export default {
  name: "PaginationBlock",
  components: { Buttons, Pager },
  props: {
    pagination: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    loadPage(page) {
      this.$emit("changePage", page);
    },
  },
};
</script>
